'use client'

import React from 'react'

import { SiteHeader } from './shadcn/SiteHeader'
import type { ResolvedHeaderNavigation } from './utilities/resolveHeaderNavigation'
import { DEFAULT_SITE_BRAND } from '@/constants/site'
import type { getPublicLanguageChromeProps } from '@/modules/languages/components/PublicLanguageChrome'

interface HeaderClientProps {
  languageChrome: Awaited<ReturnType<typeof getPublicLanguageChromeProps>>
  nav: ResolvedHeaderNavigation
  logoSrc?: string | null
  logoAlt?: string | null
  logoInvertClassName?: string
  logoWidthPx: number
  siteTitle: string
}

export const HeaderClient: React.FC<HeaderClientProps> = ({
  languageChrome,
  nav,
  logoSrc,
  logoAlt,
  logoInvertClassName,
  logoWidthPx,
  siteTitle,
}) => {
  const title = siteTitle?.trim() || DEFAULT_SITE_BRAND

  return (
    <SiteHeader
      languageChrome={languageChrome}
      logoAlt={logoAlt}
      logoInvertClassName={logoInvertClassName}
      logoSrc={logoSrc}
      logoWidthPx={logoWidthPx}
      nav={nav}
      siteTitle={title}
    />
  )
}
